export const setLevelEvaluationToken = token => ({
  type: "levelEvaluationToken/SET_LEVEL_EVALUATION_TOKEN",
  payload: token,
})
